import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect, useState } from 'react';
import { useDispatch } from '@shared/store';

export function useSetBusinessId(businessId: number) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: 'UPDATE_CURRENT_BUSINESS_ID',
      value: { businessId },
    });
  }, [businessId, dispatch]);
}

export function useInitLaunchDarkly(businessId: number) {
  const [identified, setIdentified] = useState(false);
  const ldClient = useLDClient();

  useEffect(() => {
    if (!ldClient || !businessId || identified) {
      return;
    }

    ldClient.identify({
      key: `org-${businessId}`,
      custom: {
        businessId,
      },
    });

    setIdentified(true);
  }, [ldClient, businessId, identified]);
}
